'use client';
import { Avatar, Box, Link, Tooltip, Typography, useTheme } from '@mui/material';
import { useSession } from '@toolpad/core';
import { useUserProfile } from '../../context/UserProvider';

export default function SidebarFooterAccount({ mini }) {
    const theme = useTheme();
    const session = useSession();
    const { user } = useUserProfile();
    const name = user?.name || session?.user?.name || '';
    const email = user?.email || session?.user?.email || '';
    const foreground = theme.palette.sidebar.text;
    const label = [name, email].filter(Boolean).join(' · ');
    const avatar = <Avatar src={session?.user?.image} alt={name} sx={{ width: 30, height: 30, bgcolor: 'primary.main', color: 'primary.contrastText', fontSize: '0.8125rem' }}>{(name || email).charAt(0)}</Avatar>;

    return (
        <Box component="footer" aria-label="User contact" sx={{
            bgcolor: theme.palette.sidebar.background, p: 1, width: '100%', boxSizing: 'border-box',
            borderTop: `1px solid ${theme.palette.sidebar.border}`,
        }}>
            <Tooltip title={label} placement={mini ? 'right' : 'top'}>
                <Box
                    component={email ? Link : 'div'}
                    href={email ? `mailto:${email}` : undefined}
                    aria-label={email ? (name ? `Email ${name}: ${email}` : `Email ${email}`) : undefined}
                    sx={{
                        display: 'flex', alignItems: 'center', justifyContent: mini ? 'center' : 'flex-start', gap: 1,
                        minHeight: 44, px: mini ? 0 : 1, borderRadius: 1.5,
                        bgcolor: theme.palette.sidebar.contact, color: foreground, textDecoration: 'none',
                        '&:hover': { bgcolor: theme.palette.sidebar.contact, textDecoration: email ? 'underline' : 'none' },
                        '&:focus-visible': { outline: `2px solid ${theme.palette.sidebar.accent}`, outlineOffset: 2 },
                    }}
                >
                    {avatar}
                    {!mini && <Box sx={{ minWidth: 0 }}>
                        {name && <Typography variant="body2" noWrap sx={{ color: 'inherit', fontSize: '0.8125rem', fontWeight: 700 }}>{name}</Typography>}
                        {email && <Typography variant="caption" noWrap component="span" sx={{ display: 'block', color: 'inherit', fontSize: '0.6875rem' }}>{email}</Typography>}
                    </Box>}
                </Box>
            </Tooltip>
        </Box>
    );
}

export function ToolbarAccountOverride() {
    return null;
}
